import { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <img
          src="/images/logo.jpeg"
          alt="New Aryaveer School Logo"
          className="navbar-logo"
        />

        {/* Hamburger Icon */}
        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Links */}
        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          <a href="#home" onClick={() => setIsOpen(false)}>Home</a>
          <a href="#about" onClick={() => setIsOpen(false)}>About</a>
          <a href="#vision" onClick={() => setIsOpen(false)}>Vision</a>
          <a href="#academics" onClick={() => setIsOpen(false)}>Academics</a>
          <a href="#management" onClick={() => setIsOpen(false)}>Management</a>
          <a href="#contact" onClick={() => setIsOpen(false)}>Contact</a>
        </div>
      </nav>

      {/* CSS INSIDE SAME FILE */}
      <style>{`
        .navbar {
          position: sticky;
          top: 0;
          width: 100%;
          background: #1e88e5;
          padding: 15px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 1000;
        }

        .navbar-logo {
          height: 45px;
        }

        .nav-links {
          display: flex;
          gap: 25px;
        }

        .nav-links a {
          color: white;
          text-decoration: none;
          font-weight: 500;
          transition: 0.3s;
        }

        .nav-links a:hover {
          opacity: 0.8;
        }

        /* Hamburger */
        .hamburger {
          display: none;
          flex-direction: column;
          cursor: pointer;
          gap: 5px;
        }

        .hamburger span {
          width: 25px;
          height: 3px;
          background: white;
          transition: 0.3s;
        }

        /* Mobile */
        @media (max-width: 768px) {

          .hamburger {
            display: flex;
          }

          .nav-links {
            position: absolute;
            top: 70px;
            left: 0;
            width: 100%;
            background: #1e88e5;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            padding: 20px 0;
            display: none;
          }

          .nav-links.open {
            display: flex;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;
